function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSalaryList as _getSalaryList, deleteSalaryList as _deleteSalaryList, changeCard as _changeCard, entryCard, perfectCard } from '@/api/enterprise';
import formOptions from '../mixins/index.js';
export default {
  name: 'userDetails',
  mixins: [formOptions],
  props: {
    tabtypes: {
      type: [String, Number],
      default: 1
    },
    actionType: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      drawerIsShow: false,
      tabsName: 'personalFile',
      direction: 'rtl',
      positionConfig: {},
      initData: {},
      id: '',
      photo: '',
      list: [],
      userInfo: {},
      changeList: [],
      isLoading: false
    };
  },
  watch: {
    height: function height(val) {
      this.height = val;
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      //写在mounted中,onresize事件会在页面大小被调整时触发
      return function () {
        window.screenHeight = document.body.clientHeight;
        _this.height = window.screenHeight;
      }();
    };
  },
  methods: {
    // 点击左侧菜单，右边内容跳转
    pageJump: function pageJump(id, index) {
      if (this.tabtypes === 0 && this.initData.type === 'add') {
        document.getElementById(index).scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    // 获取：个人简历头像
    getImageUrl: function getImageUrl(data) {
      this.photo = data;
    },
    //  获取：档案新增/编辑头像
    getPhoto: function getPhoto(data) {
      this.photo = data;
    },
    // 新增：取消按钮
    cancel: function cancel() {
      this.drawerIsShow = false;
    },
    // 新增：保存按钮
    protect: function protect() {
      this.$refs.addData.saveCard();
    },
    // 新增： 保存刷新
    submitOk: function submitOk() {
      this.drawerIsShow = false;
    },
    // 编辑：切换Tabs
    handleClick: function handleClick(tab) {
      var _this2 = this;
      if (tab.label == '个人经历') {
        this.getlist();
      } else if (tab.label == '调薪记录') {
        this.getSalaryList();
      } else if (tab.label == '人事异动') {
        this.changeCard();
      } else {
        setTimeout(function () {
          _this2.$refs.editData.enterpriseCardId();
        }, 100);
      }
    },
    // 编辑: 工作经历
    getlist: function getlist() {
      var _this3 = this;
      setTimeout(function () {
        _this3.$refs.editWork.enterpriseCardId();
      }, 100);
    },
    userInfoFn: function userInfoFn(data) {
      this.userInfo = data;
    },
    // 编辑：人事异动
    changeCard: function changeCard() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result, list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                card_id: _this4.id
              };
              _context.next = 3;
              return _changeCard(data);
            case 3:
              result = _context.sent;
              list = result.data.list;
              list.forEach(function (item) {
                if (item.types == 0) {
                  var isPart = {
                    0: '全职',
                    1: '兼职',
                    2: '实习',
                    3: '劳务派遣',
                    4: '退休返聘',
                    5: '劳务外包'
                  };
                  item.is_part = isPart[item.types] || '其他';
                }
              });
              _this4.changeList = list;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 编辑: 调薪弹窗
    changeSalary: function changeSalary() {
      var data = {
        title: '调薪弹窗'
      };
      this.$refs.salaryAdjustmentRecord.changeSalary(data);
    },
    // 定薪
    onSalary: function onSalary() {
      this.$refs.salaryAdjustmentRecord.dialogVisible = true;
      this.$refs.salaryAdjustmentRecord.title = '定薪';
      this.$refs.salaryAdjustmentRecord.status = 'add';
    },
    // 编辑: 获取调薪记录
    getSalaryList: function getSalaryList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                id: _this5.id
              };
              _context2.next = 3;
              return _getSalaryList(data);
            case 3:
              result = _context2.sent;
              _this5.list = result.data;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 编辑: 编辑调薪记录
    getSalaryContent: function getSalaryContent(id) {
      var data = {
        title: '编辑薪资',
        id: id
      };
      this.$refs.salaryAdjustmentRecord.editId(data);
    },
    // 编辑: 删除调薪记录
    deleteSalaryList: function deleteSalaryList(id) {
      var _this6 = this;
      this.$modalSure('确定永久删除该记录吗').then(function () {
        _deleteSalaryList(id).then(function (res) {
          _this6.getSalaryList();
        });
      });
    },
    // 编辑： 入职/重新入职
    inDuction: function inDuction(data) {
      var _this7 = this;
      this.isLoading = true;
      entryCard(this.id).then(function (res) {
        _this7.drawerIsShow = false;
        _this7.isLoading = false;
      }).then(function (err) {
        _this7.isLoading = false;
      });
    },
    // 编辑： 完善个人档案
    perfectFn: function perfectFn() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return perfectCard(_this8.id);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 打开弹窗的操作
    init: function init(data) {
      var _this9 = this;
      this.drawerIsShow = true;
      this.initData = data;
      if (this.initData.type == 'add') {
        setTimeout(function () {
          _this9.$refs.addData.defaultFn();
          _this9.photo = '';
        }, 300);
      }
      if (this.initData.type == 'edit') {
        setTimeout(function () {
          _this9.$refs.editData.enterpriseCardId();
          _this9.$refs.editData.defaultFn();
        }, 100);
      }
    },
    // 关闭弹窗的回调
    handleClose: function handleClose() {
      var set = this;
      set.tabsName = 'personalFile';
      if (this.initData.type === 'add') {
        this.photo = '';
      }
      if (set.initData.type == 'add') {
        setTimeout(function () {
          set.$refs.addData.resetForm();
        }, 100);
      }
      if (set.initData.type == 'edit') {
        setTimeout(function () {
          set.$refs.editData.resetForm();
        }, 100);
      }
      this.$emit('getList');
    }
  },
  components: {
    // 左边菜单
    LeftNavigation: function LeftNavigation() {
      return import('./LeftNavigation.vue');
    },
    // 工作经历/教育经历
    tableBox: function tableBox() {
      return import('./tableBox.vue');
    },
    // 上传图片
    UploadImage: function UploadImage() {
      return import('../src/UploadImage.vue');
    },
    // 右边表单
    formItemDataList: function formItemDataList() {
      return import('./formItemDataList.vue');
    },
    // 人事异动
    personnelChange: function personnelChange() {
      return import('./personnelChange.vue');
    },
    // 调薪记录
    salaryAdjustmentRecord: function salaryAdjustmentRecord() {
      return import('./record.vue');
    }
  }
};